module.exports = __webpack_public_path__ + "media/images/PHI-Interns-Yamamoto-c77d3d2549ffd1e06c4bf6459fdcb3b5.jpeg";